// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner.spinner-right[data-v-07be73ee] {\n  padding-right: 3.5rem !important;\n}", ""]);
// Exports
module.exports = exports;
